import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import consts from '../consts';
import imagemTemplate from '../assets/images/logo.png';
import imagemQRCode from '../assets/images/certificado_qrcode.png';
import imagemAssinatura1 from '../assets/images/certificado_assinatura1.png';
import imagemAssinatura2 from '../assets/images/certificado_assinatura2.png';
import ColorSelector from '../common/form/colorSeletor';
import {
	setModoTela, initForm
} from './certificadoModeloActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import CertificadoModeloFolha from './certificadoModeloFolha';

class CertificadoModeloForm extends Component {

	state = {

	}

    componentWillMount() {

		let initSeletorImagemTemplate = () => {
			const fileSelectorImagemTemplate = document.createElement('input');
			fileSelectorImagemTemplate.setAttribute('type', 'file');
			fileSelectorImagemTemplate.addEventListener('change', (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						this.props.initForm({
							...this.props.formularioValues,
							imagem_template: reader.result
						});

						initSeletorImagemTemplate();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagemTemplate = fileSelectorImagemTemplate;

		}

		initSeletorImagemTemplate();

		let initSeletorImagemAssinatura1 = () => {
			const fileSelectorImagemAssinatura1 = document.createElement('input');
			fileSelectorImagemAssinatura1.setAttribute('type', 'file');
			fileSelectorImagemAssinatura1.addEventListener('change', (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						this.props.initForm({
							...this.props.formularioValues,
							imagem_assinatura1: reader.result
						});

						initSeletorImagemAssinatura1();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagemAssinatura1 = fileSelectorImagemAssinatura1;

		}

		initSeletorImagemAssinatura1();

		let initSeletorImagemAssinatura2 = () => {
			const fileSelectorImagemAssinatura2 = document.createElement('input');
			fileSelectorImagemAssinatura2.setAttribute('type', 'file');
			fileSelectorImagemAssinatura2.addEventListener('change', (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						this.props.initForm({
							...this.props.formularioValues,
							imagem_assinatura2: reader.result
						});

						initSeletorImagemAssinatura2();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagemAssinatura2 = fileSelectorImagemAssinatura2;

		}

		initSeletorImagemAssinatura2();
	}

    render() {

		let readOnly = this.props.endereco || this.props.excluir ? 'readOnly' : '';

		return (
			<>
				<ContentCard>
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								<Field
									name='nome'
									component={LabelAndInput}
									label='Nome' placeholder='Informe o nome'
									cols='12 12 12 12'
									readOnly={readOnly} />

								<Grid cols='12 12 12 12'>
									<label>Tags disponíveis</label>
									<p>{'<aluno> | <instrutor> | <nome_cliente> | <curso> | <carga_horaria> | <data_emissao> | <data_inicio> | <data_fim>'}</p>
								</Grid>

								<Grid cols='12 12 12 12'>
									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>Template (1920 X 1357)</label>
										</Grid>
										{this.props.formularioValues.imagem_template ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<span class='btn btn-outline-primary fileinput-button dz-clickable'>
													<img src={this.props.formularioValues.imagem_template} style={{ height: 200 }} />
												</span>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															imagem_template: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (									
											<span class='btn btn-outline-primary fileinput-button dz-clickable'
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorImagemTemplate.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>
								</Grid>

								<Field
									name='titulo'
									component={LabelAndInput}
									label='Título' placeholder='Certificado de ...'
									cols='12 12 12 12'
									readOnly={readOnly} />
								
								<Field
									name='texto1'
									component={LabelAndInput}
									label='Texto 1' placeholder='Temos a satisfação ...'
									cols='12 12 12 12'
									readOnly={readOnly} />

								<Field
									name='texto2'
									component={LabelAndTextarea}
									label='Texto 2' placeholder='Concluiu a grade ...'
									cols='12 12 12 12'
									readOnly={readOnly}
									rows={2} />

								<Field
									name='assinatura1'
									component={LabelAndInput}
									label='Assinatura 1' placeholder='Informe a assinatura'
									cols='12 6 6 6'
									readOnly={readOnly} />

								<Field
									name='assinatura2'
									component={LabelAndInput}
									label='Assinatura 1' placeholder='Informe a assinatura'
									cols='12 6 6 6'
									readOnly={readOnly} />

								<Grid cols='6 6 6 6'>
									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>Imagem Assinatura 1 Fixa</label>
										</Grid>
										{this.props.formularioValues.imagem_assinatura1 ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<span class='btn btn-outline-primary fileinput-button dz-clickable'>
													<img src={this.props.formularioValues.imagem_assinatura1} style={{ height: 40 }} />
												</span>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															imagem_assinatura1: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (									
											<span class='btn btn-outline-primary fileinput-button dz-clickable'
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorImagemAssinatura1.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>
								</Grid>
								<Grid cols='6 6 6 6'>
									<Row style={{ paddingBottom: 16 }}>
										<Grid cols='12 12 12 12'>
											<label>Imagem Assinatura 2 Fixa</label>
										</Grid>
										{this.props.formularioValues.imagem_assinatura2 ? (
											<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 10 }}>
												<span class='btn btn-outline-primary fileinput-button dz-clickable'>
													<img src={this.props.formularioValues.imagem_assinatura2} style={{ height: 40 }} />
												</span>
												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: 40, height: 40 }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															imagem_assinatura2: null
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										) : (									
											<span class='btn btn-outline-primary fileinput-button dz-clickable'
												style={{ marginLeft: 10 }}
												onClick={() => this.fileSelectorImagemAssinatura2.click()}>
												<img src={pdfAdd} style={{ height: 40 }} />
											</span>
										)}
									</Row>
								</Grid>

								<Field
									name='texto3'
									component={LabelAndInput}
									label='Texto 3' placeholder='Módulos de ...'
									cols='12 12 12 12'
									readOnly={readOnly} />

								<Field
									name='nome_modulo1'
									component={LabelAndInput}
									label='Nome do Módulo 1' placeholder='Nome do módulo 1 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='nome_modulo2'
									component={LabelAndInput}
									label='Nome do Módulo 2' placeholder='Nome do módulo 2 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='nome_modulo3'
									component={LabelAndInput}
									label='Nome do Módulo 3' placeholder='Nome do módulo 3 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='nome_modulo4'
									component={LabelAndInput}
									label='Nome do Módulo 4' placeholder='Nome do módulo 4 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='descricao_modulo1'
									component={LabelAndTextarea}
									label='Descrição do Módulo 1' placeholder='Descrição do módulo 1 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='descricao_modulo2'
									component={LabelAndTextarea}
									label='Descrição do Módulo 2' placeholder='Descrição do módulo 2 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='descricao_modulo3'
									component={LabelAndTextarea}
									label='Descrição do Módulo 3' placeholder='Descrição do módulo 3 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />

								<Field
									name='descricao_modulo4'
									component={LabelAndTextarea}
									label='Descrição do Módulo 4' placeholder='Descrição do módulo 4 ...'
									cols='12 3 3 3'
									readOnly={readOnly} />
								
								<Field
									name='cor_fonte_titulo'
									component={LabelAndInput}
									label='Cor do Título' placeholder='#000000'
									cols='12 3 3 3'
									readOnly={readOnly} />
								
								<Field
									name='cor_fonte'
									component={LabelAndInput}
									label='Cor da Fonte Geral' placeholder='#000000'
									cols='12 3 3 3'
									readOnly={readOnly} />
								
								<Field
									name='cor_linha'
									component={LabelAndInput}
									label='Cor do Título' placeholder='#000000'
									cols='12 3 3 3'
									readOnly={readOnly} />
							</Row>
						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									{this.props.excluir ? (
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'} />
									) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
									)}
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>

				<CertificadoModeloFolha registro={{ ...this.props.formularioValues }} />
			</>
		);
    }     

}

CertificadoModeloForm = reduxForm({form: 'certificadoModeloForm', destroyOnUnmount: false})(CertificadoModeloForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('certificadoModeloForm')(state),
	registro: state.certificadoModelo.registro,
	listaDepartamento: state.departamento.listaSelect,
	listaGrupo: state.certificadoModelo.listaGrupo,
	listaCidade: state.certificadoModelo.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CertificadoModeloForm);
